// Constant Data that related to Seller Outbound Return domain

export const STATUS = {
  PENDING         : 'pending',
  ACCEPTED        : 'accepted',
  SCHEDULED       : 'scheduled',
  SELLER_RECEIVED : 'seller_received',
  CANCELLED       : 'cancelled'
}

export const RETURN_TYPE = {
  REJECTED               : 'rejected',
  AGED                   : 'aged',
  SELLER_REQUESTED       : 'seller_requested',
  DONATED                : 'donated',
  REFUNDED               : 'refunded',
  BANNED                 : 'banned',
  PRICE_CONFIRM_DEADLOCK : 'price_confirm_deadlock',
  CONSIGNMENT_EXPIRED    : 'consignment_expired',
  SOLD_BY_CONSIGNOR      : 'sold_by_consignor',
  ABOVE_MARKET_PRICE     : 'above_market_price',
  TEMPORARY_WITHDRAWAL   : 'temporary_withdrawal',
  ITEM_UNIDENTIFIED      : 'item_unidentified',
  BELOW_FAIR_CONDITION   : 'below_fair_condition'
}

export const CONSIGNOR_RETURN_CREATE_TYPE_LIST = [
  { label: 'Above Market Price', value: RETURN_TYPE.ABOVE_MARKET_PRICE },
  { label: 'Below Fair Condition', value: RETURN_TYPE.BELOW_FAIR_CONDITION },
  { label: 'Consignment Expired', value: RETURN_TYPE.CONSIGNMENT_EXPIRED },
  { label: 'Item Unidentified', value: RETURN_TYPE.ITEM_UNIDENTIFIED },
  { label: 'Sold by Consignor', value: RETURN_TYPE.SOLD_BY_CONSIGNOR },
  { label: 'Temporary Withdrawal', value: RETURN_TYPE.TEMPORARY_WITHDRAWAL }
]

export const CONSIGNOR_RETURN_CREATE_TYPE = CONSIGNOR_RETURN_CREATE_TYPE_LIST.reduce((acc, option) => {
  acc[option.value.toUpperCase()] = option
  return acc
}, {})

export const EMAIL_STATUS = {
  NOT_SENT : 'not_sent',
  SENT     : 'sent'
}

export const ITEM_STATUS = {
  ACTIVE    : 'active',
  CANCELLED : 'cancelled'
}


/** Exclude rejected return type */
export const NON_REJECTED_RETURN_TYPE = {
  [RETURN_TYPE.AGED.toUpperCase()]             : RETURN_TYPE.AGED,
  [RETURN_TYPE.SELLER_REQUESTED.toUpperCase()] : RETURN_TYPE.SELLER_REQUESTED,
  [RETURN_TYPE.DONATED.toUpperCase()]          : RETURN_TYPE.DONATED,
  [RETURN_TYPE.REFUNDED.toUpperCase()]         : RETURN_TYPE.REFUNDED,
  [RETURN_TYPE.BANNED.toUpperCase()]           : RETURN_TYPE.BANNED
}

export const COURIER = {
  SELLER          : 'seller',
  PRIVATE_COURIER : 'private_courier',
  EASYPARSEL      : 'easyparcel',
  TIKI            : 'tiki',
  JNE             : 'jne',
  GRAB            : 'grab',
  GOJEK           : 'gojek',
  SICEPAT         : 'sicepat',
  KGEXPRESS       : 'kgexpress'
}

/** Exclude Seller as courier service */
export const COURIER_DELIVERY_SERVICE = {
  [COURIER.EASYPARSEL.toUpperCase()] : COURIER.EASYPARSEL,
  [COURIER.TIKI.toUpperCase()]       : COURIER.TIKI,
  [COURIER.JNE.toUpperCase()]        : COURIER.JNE,
  [COURIER.GRAB.toUpperCase()]       : COURIER.GRAB,
  [COURIER.GOJEK.toUpperCase()]      : COURIER.GOJEK,
  [COURIER.SICEPAT.toUpperCase()]    : COURIER.SICEPAT,
  [COURIER.KGEXPRESS.toUpperCase()]  : COURIER.KGEXPRESS
}

export const SHIPMENT_TYPE = {
  GOJEK_INSTANT   : 'gojek_instant',
  PRIVATE_COURIER : 'private_courier',
  SELF_PICKUP     : 'self_pickup',
  TIKI_ONS        : 'tiki_ons',
  TIKI_REG        : 'tiki_reg',
  TIKI_SDS        : 'tiki_sds'
}

export const CONSIGNOR_RETURN_SHIPMENT_TYPE = {
  GOJEK_INSTANT: {
    label   : 'Gojek - Instant',
    value   : SHIPMENT_TYPE.GOJEK_INSTANT,
    courier : COURIER.GOJEK
  },
  PRIVATE_COURIER: {
    label   : 'Private Courier - PRIVATE COURIER',
    value   : SHIPMENT_TYPE.PRIVATE_COURIER,
    courier : COURIER.PRIVATE_COURIER
  },
  SELF_PICKUP: {
    label   : 'Self-Pickup - PICK UP IN STORE',
    value   : SHIPMENT_TYPE.SELF_PICKUP,
    courier : COURIER.SELLER
  },
  TIKI_ONS: {
    label   : 'TIKI - One Night Service',
    value   : SHIPMENT_TYPE.TIKI_ONS,
    courier : COURIER.TIKI
  },
  TIKI_REG: {
    label   : 'TIKI - Reguler',
    value   : SHIPMENT_TYPE.TIKI_REG,
    courier : COURIER.TIKI
  },
  TIKI_SDS: {
    label   : 'TIKI - Same Day Service',
    value   : SHIPMENT_TYPE.TIKI_SDS,
    courier : COURIER.TIKI
  }
}

/** Shipment cost is calculated from backend, do not hardcode it in frontend. */
export const CONSIGNOR_RETURN_ESTIMATED_SHIPPING_COST = {}

export const NON_SELLER_SHIPMENT_TYPE = {
  [SHIPMENT_TYPE.GOJEK_INSTANT.toUpperCase()]   : SHIPMENT_TYPE.GOJEK_INSTANT,
  [SHIPMENT_TYPE.PRIVATE_COURIER.toUpperCase()] : SHIPMENT_TYPE.PRIVATE_COURIER,
  [SHIPMENT_TYPE.TIKI_ONS.toUpperCase()]        : SHIPMENT_TYPE.TIKI_ONS,
  [SHIPMENT_TYPE.TIKI_REG.toUpperCase()]        : SHIPMENT_TYPE.TIKI_REG,
  [SHIPMENT_TYPE.TIKI_SDS.toUpperCase()]        : SHIPMENT_TYPE.TIKI_SDS
}

/** Shipment type only if courier is seller */
export const SELLER_SHIPMENT_TYPE = {
  [SHIPMENT_TYPE.SELF_PICKUP.toUpperCase()]: {
    label : 'Self-Pickup - PICK UP IN STORE',
    value : SHIPMENT_TYPE.SELF_PICKUP
  }
}